module.exports = __webpack_public_path__ + "static/media/your-logo-here.ea411ebf.png";